import React, { useState } from "react";
import QRGenerator from "../../../components/QRGenerator";

const CreateQRCode: React.FC = () => {
    const [eventID, setEventID] = useState("");
    const [validFrom, setValidFrom] = useState("");
    const [validTo, setValidTo] = useState("");
    const [type, setType] = useState("One-time");
    const [title, setTitle] = useState("");
    const [company, setCompany] = useState("");
    const [contactPerson, setContactPerson] = useState("");
    const [email, setEmail] = useState("");
    const [qrCodeData, setQrCodeData] = useState("");

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        const qrData = {
            eventID: Number(eventID),
            validFrom,
            validTo,
            type,
            title,
            company,
            contactPerson,
            email
        };

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/qr/create`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(qrData),
            });

            const result = await response.json();
            if (response.ok) {
                setQrCodeData(result.qrCode);
            }
        } catch (error) {
            console.error("Fejl ved oprettelse af QR-kode:", error);
        }
    };

    return (
        <div className="flex justify-center items-center min-h-screen bg-gradient-to-br from-blue-100 to-blue-300">
            <div className="bg-white p-8 rounded-xl shadow-2xl w-full max-w-lg">
                <h1 className="text-3xl font-bold text-center text-blue-700 mb-6">
                    Opret Parkerings QR-kode
                </h1>

                <form onSubmit={handleSubmit} className="space-y-6">
                    {/* Event ID */}
                    <div className="flex flex-col">
                        <label className="text-gray-700 font-medium">Event ID</label>
                        <input
                            type="number"
                            value={eventID}
                            onChange={(e) => setEventID(e.target.value)}
                            className="border border-gray-300 p-3 rounded-md focus:ring-2 focus:ring-blue-500 outline-none"
                            required
                        />
                    </div>

                    {/* Gyldig fra & til */}
                    <div className="grid grid-cols-2 gap-4">
                        <div className="flex flex-col">
                            <label className="text-gray-700 font-medium">Gyldig fra</label>
                            <input
                                type="date"
                                value={validFrom}
                                onChange={(e) => setValidFrom(e.target.value)}
                                className="border border-gray-300 p-3 rounded-md focus:ring-2 focus:ring-blue-500 outline-none"
                                required
                            />
                        </div>
                        <div className="flex flex-col">
                            <label className="text-gray-700 font-medium">Gyldig til</label>
                            <input
                                type="date"
                                value={validTo}
                                onChange={(e) => setValidTo(e.target.value)}
                                className="border border-gray-300 p-3 rounded-md focus:ring-2 focus:ring-blue-500 outline-none"
                                required
                            />
                        </div>
                    </div>

                    {/* Type */}
                    <div className="flex flex-col">
                        <label className="text-gray-700 font-medium">Type</label>
                        <select
                            value={type}
                            onChange={(e) => setType(e.target.value)}
                            className="border border-gray-300 p-3 rounded-md focus:ring-2 focus:ring-blue-500 outline-none"
                        >
                            <option value="One-time">Engangs</option>
                            <option value="All-day">Hele dagen</option>
                            <option value="Multi-day">Flere dage</option>
                        </select>
                    </div>

                    {/* Overskrift */}
                    <div className="flex flex-col">
                        <label className="text-gray-700 font-medium">Overskrift</label>
                        <input
                            type="text"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            className="border border-gray-300 p-3 rounded-md focus:ring-2 focus:ring-blue-500 outline-none"
                            required
                        />
                    </div>

                    {/* Firma */}
                    <div className="flex flex-col">
                        <label className="text-gray-700 font-medium">Firma</label>
                        <input
                            type="text"
                            value={company}
                            onChange={(e) => setCompany(e.target.value)}
                            className="border border-gray-300 p-3 rounded-md focus:ring-2 focus:ring-blue-500 outline-none"
                            required
                        />
                    </div>

                    {/* Kontaktperson */}
                    <div className="flex flex-col">
                        <label className="text-gray-700 font-medium">Kontaktperson</label>
                        <input
                            type="text"
                            value={contactPerson}
                            onChange={(e) => setContactPerson(e.target.value)}
                            className="border border-gray-300 p-3 rounded-md focus:ring-2 focus:ring-blue-500 outline-none"
                            required
                        />
                    </div>

                    {/* Email */}
                    <div className="flex flex-col">
                        <label className="text-gray-700 font-medium">Email</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="border border-gray-300 p-3 rounded-md focus:ring-2 focus:ring-blue-500 outline-none"
                            required
                        />
                    </div>

                    {/* Submit Button */}
                    <button
                        type="submit"
                        className="bg-blue-600 hover:bg-blue-700 text-white font-semibold p-4 rounded-lg transition w-full text-lg shadow-md"
                    >
                        Opret QR-kode
                    </button>
                </form>

                {/* QR-kode visning */}
                {qrCodeData && (
                    <div className="mt-6 bg-gray-100 p-6 rounded-lg text-center shadow-md">
                        <p className="text-lg font-semibold text-gray-700 mb-3">
                            QR-kode oprettet:
                        </p>
                        <div className="flex justify-center">
                            <QRGenerator value={qrCodeData} size={180} />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CreateQRCode;
